import API from "./api";

// reconciliation location

export const createLocation = (postData) =>
  API.post("/api/v1/reconciliation-location", postData);

export const getLocation = () => API.get("/api/v1/reconciliation-location");
export const deleteLocation = (id) =>
  API.delete(`/api/v1/reconciliation-location/${id}`);

// debits
export const createDebits = (postData) =>
  API.post(`/api/v1/outstanding-debit`, postData);
export const deleteDebits = (postData) =>
  API.delete(`/api/v1/outstanding-debit`, postData);
export const updateDebits = (id, postData) =>
  API.patch(`/api/v1/outstanding-debit/${id}`, postData);

// CREDITS
export const createCredits = (postData) =>
  API.post(`/api/v1/outstanding-credit`, postData);

export const deleteCredit = (postData) =>
  API.delete(`/api/v1/outstanding-credit`, postData);

export const updateCredits = (id, postData) =>
  API.patch(`/api/v1/outstanding-credit/${id}`, postData);

// submissions
export const createSubmission = (postData) =>
  API.post("/api/v1/reconciliation-submission", postData);
export const deleteSubmission = (postData) =>
  API.delete(`/api/v1/reconciliation-submission`, postData);

export const updateSubmission = (branch, date, postData) =>
  API.patch(`/api/v1/reconciliation-submission/${branch}/${date}`, postData);
// sign in a new user
export const signIn = (formData) => API.post("/api/v1/users/login", formData);
// the user already signed in to another app, if any (shared login cookie)
export const fetchSignedInUser = () => API.get("/api/v1/users/me");
// ends the shared login for every app in this browser
export const signOut = () => API.post("/api/v1/users/logout");
// Sign up a new user
export const signup = (formData) => API.post("/api/v1/users/signup", formData);

// Security
// forgot password
export const forgotPassword = (postData) =>
  API.post("/api/v1/users/forgotPassword", postData);

// reset password
export const resetPassword = (token, postData) =>
  API.patch(`/api/v1/users/resetPassword/${token}`, postData);

// reset password
export const changePassword = (postData) =>
  API.patch(`/api/v1/users/updateMypassword`, postData);

export const getUsers = () => API.get("/api/v1/users");
export const getDebitStats = () =>
  API.get("/api/v1/outstanding-debit/outstanding-debit/stats/branch");
export const getCreditStats = () =>
  API.get("/api/v1/outstanding-credit/outstanding-credit/stats/branch");
// ! Update users information and delete users
export const updateUser = (id, postData) =>
  API.patch(`/api/v1/users/update-user/info/${id}`, postData);
export const deleteUser = (id) =>
  API.delete(`/api/v1/users/delete-selected-user/info/${id}`);

// reconciliation analysis
export const getHeadOfficeCreditStats = () =>
  API.get(
    "/api/v1/reconciliation-submission/reconciliation-submission/primary/credit-stats"
  );
export const getBranchCreditStats = () =>
  API.get(
    "/api/v1/reconciliation-submission/reconciliation-submission/secondary/credit-stats"
  );
export const getHeadOfficeDebitStats = () =>
  API.get(
    "/api/v1/reconciliation-submission/reconciliation-submission/primary/debit-stats"
  );
export const getBranchDebitStats = () =>
  API.get(
    "/api/v1/reconciliation-submission/reconciliation-submission/secondary/debit-stats"
  );

// Open items worked out on the server: totals per statement, and one
// statement's items when a chart bar is clicked
export const getOutstandingSummary = () =>
  API.get(
    "/api/v1/reconciliation-submission/reconciliation-submission/outstanding-summary"
  );
export const getOutstandingItems = (branches, olderThan) => {
  const params = new URLSearchParams();
  branches.forEach((name) => params.append("branch", name));
  if (olderThan) params.append("olderThan", olderThan);
  return API.get(
    `/api/v1/reconciliation-submission/reconciliation-submission/outstanding-items?${params}`
  );
};

// Authenticator-app sign-in: the code step after a correct password
export const twoFactorLoginVerify = (postData) =>
  API.post("/api/v1/users/two-factor/login/verify", postData);
export const twoFactorLoginSetup = (postData) =>
  API.post("/api/v1/users/two-factor/login/setup", postData);
export const twoFactorLoginSetupConfirm = (postData) =>
  API.post("/api/v1/users/two-factor/login/setup/confirm", postData);
// ...and the signed-in user's own authenticator app
export const getMyTwoFactor = () => API.get("/api/v1/users/two-factor/me");
export const startMyTwoFactorSetup = () =>
  API.post("/api/v1/users/two-factor/me/setup");
export const enableMyTwoFactor = (code) =>
  API.post("/api/v1/users/two-factor/me/enable", { code });
export const disableMyTwoFactor = (postData) =>
  API.post("/api/v1/users/two-factor/me/disable", postData);
export const newMyBackupCodes = (code) =>
  API.post("/api/v1/users/two-factor/me/backup-codes", { code });
